export default "__VITE_ASSET__91425b5f__"